import React, { forwardRef, useEffect, useState } from "react";
import getClasses from "../../../../utils/getClasses";
require("./CustomCheckbox.scss");
type Props = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

const CustomCheckbox = forwardRef<HTMLElement, Props>(
  ({ label, checked, onChange }, refinput) => {
    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
      setIsChecked(checked);
    }, [checked]);

    const handleCheckboxChange = () => {
      const newChecked = !isChecked;
      setIsChecked(newChecked);
      onChange(newChecked);
    };

    return (
      <div className="custom-checkbox-container">
        <label className="custom-checkbox">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          <span className="checkmark"></span>
          {label}
        </label>
      </div>
    );
  }
);

export default CustomCheckbox;
